<script setup lang="ts">
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'
import { useRewardsStore } from '@/stores/rewards'
import { formatNumber } from '@/utils/format'

const { t } = useI18n()
const rewards = useRewardsStore()

onMounted(() => {
  void rewards.refreshPoints()
})
</script>

<template>
  <span
    class="hidden items-center gap-1.5 rounded-full bg-reybex-orange px-2.5 py-1 text-xs font-semibold text-white shadow-sm sm:inline-flex"
    :title="t('dashboard.totalPoints')"
  >
    <AppIcon name="gem" size="xs" class="animate-gem-spin" />
    <span class="animate-points-tick">{{ formatNumber(rewards.totalPoints ?? 0) }}</span>
  </span>
</template>
